<template>
  <section class="pa-section pa-section-registration">
    <div class="pa-golden-wide-box pa-select-passport">
      <p class="title title-double-line">新規接続申請<span class="mini">-&nbsp;旅券選択&nbsp;-</span></p>
      <div class="content content-center">
        <p>異界舞踏会アキバトリカルへの接続登録を行います。</p>
        <p>異界舞踏会アキバトリカルへの接続時にご利用になられる旅券をお選びください。</p>
      </div>

      <swiper :options="swiperOptions" ref="loginSelectPassportSwiper">
        <swiper-slide>
          <div class="login-passport-card">
            <div class="title">
              <LoginEmailTitle />
            </div>

            <div class="description">
              <p>メールアドレスにて個人識別を行う旅券でございます。</p>
            </div>

            <div class="control-button" @click.prevent="selectEmailPassport">
              <RegistrationCardSelectButton />
            </div>

            <div class="tiket_valid">
              <LoginTicketValid />
            </div>

            <div class="tiket_valid_cut">
              <LoginTicketCut />
            </div>
          </div>
        </swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
  </section>
</template>

<script>
import LoginEmailTitle from '@/views/Registration/Images/login_mail_title.svg?inlineF'
import RegistrationCardSelectButton from '@/views/Registration/Images/register_card_select.svg?inlineN'
import LoginTicketValid from '@/components/FrontParts/LoginModal/LoginBox/Images/login_ticket_valid.svg?inlineF'
import LoginTicketCut   from '@/components/FrontParts/LoginModal/LoginBox/Images/login_tiket_cut.svg?inlineF'

import FrontPageMixins from '@/mixins/FrontPageMixins'

export default {
  mixins : [
    FrontPageMixins
  ],
  
  components : {
    LoginEmailTitle,
    RegistrationCardSelectButton,
    LoginTicketValid,
    LoginTicketCut
  },
  
  data : function(){
    return {
      swiperOptions : {
        slidesPerView : 1,
        loop          : false,
        speed         : 800,
        pagination: {
          el        : '.swiper-pagination',
          clickable : true
        },
        on: {
          init : function(){
          }
        }
      }
    };
  },

  methods : {
    selectEmailPassport(){
      this.$router.push({name:'registration.withEmail'});
    }
  },

  computed: {
    swiper() {
      return this.$refs.loginSelectPassportSwiper.$swiper;
    },
  },

  async mounted(){
    await this.initializePage();
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
@import "@/assets/scss/_variables.scss";

.pa-section{
  &-registration{
    .pa-select-passport{
      .login-passport-card{
        margin: 0 2vw;
        background-color: #7A4E26;
        border:8px solid #603411;
        border-radius: 12px;
        font-size:.8rem;
        line-height: 1.3rem;
        text-align: center;

        @include from('540px'){
          max-width:440px;
          margin:0 auto;
        }

        div.title{
          margin-bottom:0;

          svg{
            width:9rem;
            margin:0 auto;
            padding:.4rem 0 .6rem;
          }
        }

        div.description{
          color: #000000;
        }

        div.control-button{
          margin-top:.6rem;

          svg{
            margin:0 auto;
            width:6rem;

            .cls-2{
              fill: #e8c5ac;
            }
          }
        }

        div.tiket_valid_cut{
          z-index: 807;
          position: absolute;
          opacity:0;
          right:2rem;
          bottom:-8px;

          svg{
            width:35px;
          }
        }

        div.tiket_valid{
          z-index: 806;
          opacity: 0;
          position: absolute;
          right:2rem;
          bottom:-8px;

          svg{
            width:35px;
          }
        }
      }

      .swiper-pagination{
        margin-top:.6rem;
        position: static;

        .swiper-pagination-bullet{
          box-sizing: border-box;
          border:4px solid $swiper-pagination-bullet-border;
          background-color: #7A4E26;

          width:20px;
          height: 20px;
          border-radius: 50%;
          margin-right:15px;

          opacity: .9;
        }

        .swiper-pagination-bullet-active{
          background-color: #BA833F;
        }

        .swiper-pagination-bullet::before{
          content: "";
        }
      }
    }
  }
}
</style>